import { expected } from '@aloft/toolkit-shared';

import { useContext } from 'react';

import { ToolkitControllerGlobalContext } from '../consts.ts';
import { ToolkitControllerGlobal } from '../types.ts';

export const useToolkitControllerGlobal = (
  iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError = false,
): ToolkitControllerGlobal => {
  const msg = 'useToolkitControllerGlobal called outside of ToolkitController';
  const globalContext = useContext(ToolkitControllerGlobalContext);

  if (globalContext) return globalContext;

  const context = iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError ? {} : undefined;

  return expected(context, msg) as ToolkitControllerGlobal;
};
